var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMshraiLogoM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#00CEBC",
    rx: 22.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M5 12h34.737v22H5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(.0072 0 0 .01136 0 -.017)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAABbCAYAAABDJ3bQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAUTSURBVHhe7d3Nb1RVGMfxZzov2NJWOjGEvk2LNQEXCqEOIBKbuFAMC2k0iBATCG5kbYJ/gBsXJiZqQ2y0QbRFSbR1QdRookZja5UXk4IBJgq00EDbaeN0Ggqd8Tw35yJUZuaZO/el7f19koacs6P5cp47Z6YlQCe+zRKAQJn+E6AgxAJiiAXEEAuIIRYQQywghlhADLEsdnNzRFl3rspciSWYmqbYoY+pInFR74Adgqk0NXV2U/SHfleCcTyW4HSamjs+opqBkxT74CiCsQl/X+t7eun+wdO0qvdrFcyA48E4GktkbIKa3ztMlWcvGOtlV68hGBsYoXT30or+ExTIZCk89Y8K5ivHTxjHYuHR0/Tuf6GYzGAqz57XO1CMYDpNjR9+ejsUEwdT39NH0R+dO2EcicUcPRUXh/XO3TiYhiOf44QpEodS/0kvVZ8cuisUU9nsTWrgE+fXU44EY3ss80dPLhhJxTFGjwplxS/qRMkTQkAFE+OTx4FgbI0l1+jJhYNZ/U4Xlf89onfgXgLq5XFTx5GCoZjMYOweSbbFUnZjlmKdPTlHTy4hNWtXv91phAP/F5jLGNcOVWfOiUIxcTA8kpaf/0vvlM62WDKRMCW3tFImHNI7cvxw1vJmB4KZh+9RYofUifLbH3qnOJMbHqF0c6Nelc6+MRQI0OTG9TSyu52y4bDelONgHnzrfaq4gGcYFpyeocYu9exhMZSJJ+J0ed9Oyqp/xHax9wFXBTPRtoku7X/RUjCR8aR6Wageen0eDIdSp0ZI9akhvVOc5OYNNPLy87aGwuyNhekTxmow96lR5OdgImNJI5Sa/t/v+fK4EA5leO9OyiyzNxRmfyzMHEl7dtDN6iq9KcfBNBw+5ruX1fyMUtf9hfVQ4usdC4U5EwtTwYw/uYlG27dZCqZ8+Kqv7mHM93qqT5+xfqLs3+VYKMy5WJh+hrEajHlxJ723Wazmv9dTjEwo5OjouZOzsbDbwTyj/jIRvSnHwTR2fbZk30vK9V6PhBHKllZXQmHOx8KMYDYbL+Ws3MNEro8vyfeSCr3Xkw+HMrVxHY2+sN2VUJg7sTD90HuZ56qFYPiEWdX3jV4tDdHvB8RX+HcyQ7my6zm6VbVc7zrPvViYDma0/VlLwfAV9lISmp4pOhQ29dijrofC3I2FqWCub2uzfML4HT/M8jh3OxTmfiysxJHkV2Yodt/MSnkTCzODeeUlyoaCehNymXi81dNQmHexMA4mvo5uWbiD8ZvJrXFPQ2HexsJUMFn1Bflly7z/HnkfCywaiAXEEAuIIRYQQywghlhADLGA2IL4PbgPv/aG8WHtQlJrWijx+gG9skfNT4PGT1FKJLfGafaBqF6VrvbYcVp5/Du9yi9x8FVKrX1Ir7zh+5Ml+vOg8dEHyRd/mNrPMIZADLGAGGIBMcQCYogFxBALiCEWEEMsIIZYQAyxgBhiATHEAmKIBcQQC4ghFhBDLCCGWEAMsYAYYgExxAJiiAXEEAuIIRYQQywghlhADLGAGGIBsQXxg/G1R7+kUCqtV7nNxGpp7Ok2vbIH/9+MlX8m9Cq/xMEDlFrbolel41/FXjV0Tq/yu7b9KbpRu1KvvLEgYvGSl7EsNhhDIIZYQAyxgBhiATHEAmKIBcQQC4ghFhBDLCCGWEDM99f9dd19VH5pRK/yu7J7B83E6vTKf3wfC8hhDIEYYgExxAJiiAXEEAuIIRYQQywghlhAiOhfJuvwbBWM044AAAAASUVORK5CYII=",
    id: "b",
    width: 139,
    height: 91
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMshraiLogoM);
export default __webpack_public_path__ + "static/media/mshraiLogoM.24a58910e63b4003159f407f7685fdcc.svg";
export { ForwardRef as ReactComponent };